"use strict";

var _classCallCheck = require("/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/classCallCheck.js").default;
var _createClass = require("/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/createClass.js").default;
var _inherits = require("/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/inherits.js").default;
var _createSuper = require("/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/createSuper.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LongCSSPropertyValidator = void 0;
var _GenericPropertyValidator = require("./GenericPropertyValidator");
var LongCSSPropertyValidator = /*#__PURE__*/function (_GenericPropertyValid) {
  _inherits(LongCSSPropertyValidator, _GenericPropertyValid);
  var _super = _createSuper(LongCSSPropertyValidator);
  function LongCSSPropertyValidator(params) {
    _classCallCheck(this, LongCSSPropertyValidator);
    return _super.call(this, params, false);
  }
  /**
   * Normalize a rule value from inline CSS styles.
   *
   * @param value - The CSS property value to test.
   * @returns The normalized value, or null if normalization failed.
   */
  _createClass(LongCSSPropertyValidator, [{
    key: "normalizeInlineCSSValue",
    value: function normalizeInlineCSSValue(value) {
      if (typeof value !== 'string') {
        return value;
      }
      return this.normalizeRawInlineCSSValue(value);
    }

    /**
     * Normalize a mixed value from a @{link MixedStyleDeclaration}.
     *
     * @param value
     */
  }, {
    key: "normalizeNativeValue",
    value: function normalizeNativeValue(value) {
      return value;
    }
  }]);
  return LongCSSPropertyValidator;
}(_GenericPropertyValidator.GenericCSSPropertyValidator);
exports.LongCSSPropertyValidator = LongCSSPropertyValidator;